import axios from 'axios';

// Base API URL
//const API_BASE_URL = 'https://f93f4894-6fc1-43f3-8b6c-c61b254b6fc4.clouding.host/api';
const API_BASE_URL = '85583adb-06b4-41dd-839f-241c1405c5ae.clouding.host';

// Function to get user email from localStorage
const getUserEmail = () => {
  try {
    const userInfo = localStorage.getItem('user_info');
    if (userInfo) {
      const parsedUserInfo = JSON.parse(userInfo);
      return parsedUserInfo.email || '';
    }
    return '';
  } catch (error) {
    console.error('Error getting user email:', error);
    return '';
  }
};

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add a request interceptor to include email in all requests
apiClient.interceptors.request.use(
  (config) => {
    const email = getUserEmail();
    
    // If it's a GET request, add email as a query parameter
    if (config.method === 'get') {
      config.params = { ...config.params, email };
    }
    // For other request types, add email to the request body if it exists
    else if (config.data) {
      // If data is a FormData object
      if (config.data instanceof FormData) {
        config.data.append('email', email);
      } 
      // If data is a string (JSON)
      else if (typeof config.data === 'string') {
        try {
          const data = JSON.parse(config.data);
          data.email = email;
          config.data = JSON.stringify(data);
        } catch (e) {
          config.data = config.data;
        }
      } 
      // If data is an object
      else {
        config.data = { ...config.data, email };
      }
    } else {
      // If no data exists, create a data object with email
      config.data = { email };
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Login function
export const login = async (username, password) => {
  try {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    const response = await axios.post(`${API_BASE_URL}/login`, formData);
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Register function
export const register = async (userData) => {
  try {
    const formData = new FormData();
    for (const key in userData) {
      formData.append(key, userData[key]);
    }

    const response = await axios.post(`${API_BASE_URL}/register`, formData);
    return response.data;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

// Create a new bot
export const createBot = async (botData) => {
  try {
    // Format options data if present
    if (botData.options && Object.keys(botData.options).length > 0) {
      // Convert from {optionId: value} format to array format for API
      const formattedOptions = Object.entries(botData.options).map(([optionId, value]) => ({
        option_id: parseInt(optionId),
        value: value
      }));
      
      botData.option_values = formattedOptions;
      // Keep the original options object for frontend use
    }
    
    const response = await apiClient.post('/notto/bots', botData);
    return response.data;
  } catch (error) {
    console.error('Error creating bot:', error);
    throw error;
  }
};

// Get a specific bot
export const getBot = async (botId) => {
  try {
    const response = await apiClient.get(`/notto/bots/${botId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching bot ${botId}:`, error);
    throw error;
  }
};

// Create provider connections
export const createProviderConnections = async (providerCredentials, botId = null) => {
  try {
    const payload = {
      provider_credentials: providerCredentials
    };
    
    if (botId) {
      payload.bot_id = botId;
    }
    
    const response = await apiClient.post('/notto/provider_connections', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating provider connections:', error);
    throw error;
  }
};

// Get a specific connection
export const getConnection = async (connectionId) => {
  try {
    const response = await apiClient.get(`/notto/connections/${connectionId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching connection ${connectionId}:`, error);
    throw error;
  }
};

// Create a single connection
export const createConnection = async (botId, providerId, name, credentials) => {
  try {
    const response = await apiClient.post('/notto/provider_connections', {
      bot_id: botId,
      provider_id: providerId,
      name,
      credentials
    });
    return response.data;
  } catch (error) {
    console.error('Error creating connection:', error);
    throw error;
  }
};

// Upload attachment to a bot
export const uploadBotAttachment = async (botId, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    // Get user email and append to formData
    const email = getUserEmail();
    if (email) {
      formData.append('email', email);
    }

    const response = await axios.post(
      `${API_BASE_URL}/notto/bots/${botId}/attachments`, 
      formData, 
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error(`Error uploading attachment to bot ${botId}:`, error);
    throw error;
  }
};

// Delete attachment from a bot
export const deleteBotAttachment = async (botId, attachmentId) => {
  try {
    const response = await apiClient.delete(`/notto/bots/${botId}/attachments/${attachmentId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting attachment ${attachmentId} from bot ${botId}:`, error);
    throw error;
  }
};

// Export all functions as named exports
export default {
  login,
  register,
  createBot,
  getBot,
  createProviderConnections,
  getConnection,
  createConnection,
  uploadBotAttachment,
  deleteBotAttachment
}; 

export const claudeRequest = async (formData) => {
  try {
    const response = await apiClient.post('/claude', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error making Claude request:', error);
    throw error;
  }
} 


export { rubricaAPI } from './rubricaAPI';